import {i18n} from '@netx/core/i18n';

export const CategoriesLabel = {
	ROUTE: i18n.t('i18n.categories'),
};

export const CategoryActionLabel = {
	ADD: i18n.t('i18n.addCategory'),
	ADD_SUBFOLDER: i18n.t('i18n.addSubCategory'),
	DELETE: i18n.t('i18n.deleteCategory'),
	EDIT: i18n.t('i18n.editCategory'),
	IMPORT: i18n.t('i18n.importToCategory'),
	SEARCH_ALL_ASSETS: i18n.t('i18n.listAll'),

	CREATE_PDF: i18n.t('i18n.createPDF'),
	CREATE_PDF_SHARE_LINK: i18n.t('i18n.createLink'),
	CREATE_PDF_DOWNLOAD: i18n.t('i18n.download'),
	DOWNLOAD: i18n.t('i18n.download'),
	MENU: i18n.t('i18n.share'),
	SHARE_LINK: i18n.t('i18n.createLink'),
	SHARE_FEED: i18n.t('i18n.createFeed'),
};
